export default __webpack_public_path__ + "static/media/icn_escrow1.255029ce.svg";